import {
  AkaCriticalIllnessInsuranceType,
  CriticalIllnessInsuranceType,
} from "../../adviceTypes";

import Accordion from "@storeblocks/accordion";
import { useTexts } from "Components/TextContext";
import React from "react";
import ReactMarkdown from "react-markdown";
import { StyledRow } from "./styled";
import { AdviceInsuranceType } from "./utils";

interface Props {
  insuranceType: AdviceInsuranceType;
}

export const PayoutInformation = ({
  insuranceType,
}: Props): React.ReactElement | null => {
  const { getText } = useTexts();
  const criticalIllnessType =
    insuranceType === CriticalIllnessInsuranceType.CRITICAL_ILLNESS_NOT_SMOKER;
  const akaCriticalIllnessType =
    insuranceType === AkaCriticalIllnessInsuranceType.AKA_CRITICAL_ILLNESS;

  if (!criticalIllnessType && !akaCriticalIllnessType) {
    return null;
  }

  return (
    <Accordion style={{ width: "100%" }}>
      <StyledRow
        id="payout-information"
        headerProps={{ type: "button" }}
        header={getText(
          criticalIllnessType
            ? "advicepage.criticalillness.cardadvicepayoutinformationheader"
            : "advicepage.akacriticalillness.cardadvicepayoutinformationheader",
        )}
        content={
          <ReactMarkdown>
            {getText(
              criticalIllnessType
                ? "advicepage.criticalillness.cardadvicepayoutinformation"
                : "advicepage.akacriticalillness.cardadvicepayoutinformation",
            )}
          </ReactMarkdown>
        }
      />
    </Accordion>
  );
};
